<template>
  <div class="guide-container">
    <Header title="办事指南" />
    <div class="guide-inner">
      <header>
        <div class="info">
          <p>{{ serviceDetail.employInfo.employName }}</p>
          <div>
            <el-rate v-model="serviceDetail.score" disabled show-score text-color="#F8AE00"></el-rate>
            <span>平均办理时长：{{ serviceDetail.handleTime | timeFilter }}</span>
            <span>办理数：{{ serviceDetail.usedNumber }}</span>
          </div>
        </div>
        <div class="buttons" v-if="isLogin">
          <el-button type="primary" @click="collectService">
            {{ serviceDetail.collected ? '取消收藏' : '收藏' }}</el-button>
          <el-button type="primary" @click="dialogVisible = true">评分</el-button>
          <el-button type="primary" v-if="serviceDetail.employInfo.handleWay !== 1"
            @click="$router.push(`handle?employId=${employId}&formId=${serviceDetail.employInfo.formId}&deployId=${serviceDetail.employInfo.deployId}`)">
            办理
          </el-button>
        </div>
      </header>
      <el-divider></el-divider>
      <section>
        <div class="part">
          <b>基本信息</b>
          <el-divider></el-divider>
          <el-descriptions :column="3">
            <el-descriptions-item label="服务名称">{{ serviceDetail.employInfo.employName }}</el-descriptions-item>
            <el-descriptions-item label="负责部门">{{ serviceDetail.employInfo.departmentName }}</el-descriptions-item>
            <el-descriptions-item label="服务角色">{{ serviceDetail.employInfo.roles | rolesFilter }}</el-descriptions-item>
            <el-descriptions-item label="业务分类">{{ serviceDetail.employInfo.categoryName }}</el-descriptions-item>
            <el-descriptions-item label="办理方式">{{ ['线下办理', '线上办理', '线上线下结合'][serviceDetail.employInfo.handleWay - 1]
              }}</el-descriptions-item>
            <el-descriptions-item label="业务周期">{{ ['常年', '学期内'][serviceDetail.employInfo.cycleType - 1]
              }}</el-descriptions-item>
            <el-descriptions-item label="办理时长">{{ serviceDetail.employInfo.handleDays }}天</el-descriptions-item>
            <el-descriptions-item label="受理条件">{{ serviceDetail.employInfo.acceptConditions }}</el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="part" v-for="item in serviceGuide" :key="item.informationId">
          <b>{{ item.title }}</b>
          <el-divider></el-divider>
          <div class="content" v-html="item.content"></div>
        </div>
      </section>
    </div>
    <Footer />

    <el-dialog :visible.sync="dialogVisible" width="500px" title="评分" center top="30vh" :show-close="false">
      <el-rate show-score v-model="selectRate"></el-rate>
      <el-button type="primary" @click="serviceScore">确定</el-button>
    </el-dialog>
  </div>
</template>

<script>
import * as api from './api'
export default {
  name: "Guide",
  components: {
    Header: () => import('../../components/Header'),
    Footer: () => import('../../components/Footer')
  },
  data() {
    return {
      isLogin: localStorage.getItem('sys_token'),
      employId: '',
      serviceDetail: {
        isLogin: localStorage.getItem('sys_token'),
        employInfo: {
          roles: ''
        }
      },
      serviceGuide: [],
      dialogVisible: false,
      selectRate: 0
    }
  },
  filters: {
    rolesFilter(roles) {
      let roleName = []
      roles.split(',').forEach(role => {
        roleName.push(['教师', '学生', '游客'][role - 1])
      })
      return roleName.join('、')
    },
    timeFilter(totalMinutes) {
      const days = Math.floor(totalMinutes / (60 * 24))
      const hours = Math.floor((totalMinutes % (60 * 24)) / 60)
      const minutes = totalMinutes % 60
      let result = []
      if (days > 0) result.push(`${days}天`)
      if (hours > 0) result.push(`${hours}小时`)
      if (minutes > 0 || result.length === 0) result.push(`${minutes}分钟`)
      return result.join('')
    }
  },
  async created() {
    this.employId = this.$route.query.employId
    const { data } = await api.getServiceDetail({
      employId: this.employId,
      userId: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).id : null
    })
    this.serviceDetail = data
    const { data: { informationList } } = await api.getServiceGuide(this.employId)
    this.serviceGuide = informationList
  },
  methods: {
    async serviceScore() {
      const { data: { score } } = await api.serviceScore({
        employId: this.employId,
        score: this.selectRate
      })
      this.serviceDetail.score = score
      this.$message.success('已评分')
      this.dialogVisible = false
    },
    async collectService() {
      await api.collectService(this.employId)
      this.$message.success(this.serviceDetail.collected ? '已取消收藏' : '已收藏')
      this.serviceDetail.collected = !this.serviceDetail.collected
    }
  }
}
</script>

<style lang="scss" scoped>
.guide-container {

  .guide-inner {
    min-height: 100vh;
    width: var(--inner-width);
    margin: auto;
    padding: 120px 0 50px;

    p {
      font-family: serif;
    }

    >.el-divider {
      height: 2px;
      background: $mainColor;
    }

    header {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .info {
        display: flex;
        flex-direction: column;
        gap: 20px;

        p {
          font-size: 35px;
          font-weight: bold;
          color: #333;
        }

        >div {
          display: flex;
          gap: 50px;
          align-items: center;

          .el-rate {
            zoom: 1.2;
          }
        }
      }

      .buttons {
        margin-left: auto;
        display: flex;
        gap: 10px;
      }
    }

    section {
      .el-descriptions {
        zoom: 1.2
      }

      .content {
        color: #606266;
        line-height: 1.5;
      }

      .part {
        margin-top: 50px;

        b {
          font-size: 24px;
          color: #333;
          font-weight: bold;
          font-family: serif;
        }

        .el-divider {
          margin: 10px 0 20px;
        }
      }
    }
  }

  ::v-deep.el-dialog {
    &__header {
      border: none;
    }

    &__body {
      display: flex;
      flex-direction: column;
      gap: 50px;
      align-items: center;

      .el-rate {
        zoom: 2;

        &__text {
          margin-left: 8px;
        }
      }
    }
  }
}
</style>